import { Inject, Injectable } from '@angular/core';
import { TEngineeri8EnvironmentVars } from '@monorepo/types';

export const Engineeri8EndPoints = {
  // product type master
  SEARCH_PRODUCT_TYPE_MASTER: '/api/v1/productTypes/search',
  ADD_NEW_PRODUCT_TYPE_MASTER: '/api/v1/productTypes',
  GET_ALL_PRODUCT_TYPES: '/api/v1/productTypes/options',
  DELETE_PRODUCT_TYPE_MASTER: '/api/v1/productTypes/:id/delete',

  // operation master
  SEARCH_OPERATION_MASTER: '/api/v1/operations/search',
  ADD_NEW_OPERATION_MASTER: '/api/v1/operations',
  DELETE_OPERATION_MASTER: '/api/v1/operations/:id/delete',

  // part master
  SEARCH_PART_MASTER: '/api/v1/parts/search',
  ADD_NEW_PART_MASTER: '/api/v1/parts',
  DELETE_PART_MASTER: '/api/v1/parts/:id/delete',

  // style master
  SEARCH_STYLE_MASTER: '/api/v1/styles/search',
  ADD_NEW_STYLE_MASTER: '/api/v1/styles',
  DELETE_STYLE_MASTER: '/api/v1/styles/:id/delete',

  // machine master
  SEARCH_MACHINE_MASTER: '/api/v1/machines/search',
  ADD_NEW_MACHINE_MASTER: '/api/v1/machines',
  DELETE_MACHINE_MASTER: '/api/v1/machines/:id/delete',

  // allowance master
  GET_BUNDLE_ALLOWANCE: '/api/v1/bundleAllowance',
  UPDATE_BUNDLE_ALLOWANCE: '/api/v1/bundleAllowance/update',
  ADD_NEW_FATIGUE_ALLOWANCE_MASTER: '/api/v1/fatigueAllowances',
  SEARCH_FATIGUE_ALLOWANCE_MASTER: '/api/v1/fatigueAllowances/search',
  UPDATE_FATIGUE_ALLOWANCE_MASTER: '/api/v1/fatigueAllowances/update',
  DELETE_FATIGUE_ALLOWANCE_MASTER: '/api/v1/fatigueAllowances/:id/delete',

  // Library API
  FETCH_ALL_METHODS: '/api/v1/methods',
  FETCH_ALL_OPERATION_BREAKDOWNS: '/api/v1/operationBreakdowns',
};

@Injectable({ providedIn: 'root' })
export class Engineeri8EnvironmentService {
  #API_URL: string;

  constructor(@Inject('environment') envValues: TEngineeri8EnvironmentVars) {
    this.#API_URL = envValues.protocol + envValues.service_host + envValues.engineeri8;
  }

  public getUrlFromEnv(arg: keyof typeof Engineeri8EndPoints): string {
    return this.#API_URL + Engineeri8EndPoints[arg];
  }
}
